module.exports = __webpack_public_path__ + "5e4a2303390f4c6ce8184d324c4b7ba4.jpg";